import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CurrentProductService } from '@spartacus/storefront';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { SikoB2bRecommendationStateService } from '@siko/features/recommendation';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AsyncPipe } from '@angular/common';
import { SikoB2bCarouselComponent } from '@siko/features/product/product-carousels/swiper-carousel/swiper-carousel.component';
import { I18nModule } from '@spartacus/core';

@Component({
   selector: 'siko-b2b-product-detail-you-might-like-refecences-carousel',
   imports: [AsyncPipe, SikoB2bCarouselComponent, I18nModule],
   templateUrl: './product-detail-you-might-like-refecences-carousel.component.html',
   styleUrl: './product-detail-you-might-like-refecences-carousel.component.scss',
   changeDetection: ChangeDetectionStrategy.OnPush,
   host: {
      class: 'w-100'
   },
})
export class SikoB2bProductDetailYouMightLikeRefecencesCarouselComponent {
   readonly currentProductService = inject(CurrentProductService);

   readonly recommendationStateService = inject(SikoB2bRecommendationStateService);

   constructor() {
      this.currentProductService
         .getProduct()
         .pipe(
            map(product => product?.code),
            distinctUntilChanged(),
            filter((productCode): productCode is string => !!productCode),
            takeUntilDestroyed()
         )
         .subscribe(productCode => {
            this.recommendationStateService.loadProductDetailYouMightLike(productCode);
         });
   }
}
